/*
 * blazingcard
 * version 4.5
 * http://www.blazingcard.com
 *
 * Copyright (c) 2021 Kellton Tech Pvt Ltd
 * Author Kellton Tech Pvt Ltd <support@blazingcard.com>
 * Licensed under the MIT license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { Api } from '../providers/api/api';

@Injectable({
  providedIn: 'root'
})
export class MediaService extends Api {
  // address url
  private url: string;

  /**
   * Handles 'CreateFolder' function. Calls post method with specific api address
   * along its param.
   *
   * @param param from model.
   */
  CreateFolder(param): Observable<any> {
    return this.http.post(
      (this.url = this.getBaseUrl() + '/media/create-folder'),
      param
    );
  }

  /**
   * Handles 'document' function. Calls post method with specific api address
   * along its param.
   *
   * @param param from model.
   */

  document(param): Observable<any> {
    const formData = new FormData();
    formData.append('image', param);
    formData.append('path', param.path);

    const options: {
      headers?: HttpHeaders;
      observe?: 'body';
      params?: HttpParams;
      reportProgress?: boolean;
      responseType: 'text';
      withCredentials?: boolean;
    } = {
      headers: new HttpHeaders({ 'xss-loader': 'true' }),
      withCredentials: true,
      responseType: 'text' as 'text'
    };

    return this.http.post(
      (this.url = this.getBaseUrl() + '/media/upload-file'),
      param
    );
  }

  /**
   * Handles 'deleteFolder' function. Calls post method with specific api address
   * along its param.
   *
   * @param param from model.
   */

  deleteFolder(param): Observable<any> {
    return this.http.post(
      (this.url = this.getBaseUrl() + '/media/create-folder'),
      param
    );
  }

  /**
   * Handles 'bucketLists' function. Calls get method with specific api address
   * along its param.
   *
   * @param param from model.
   */

  bucketLists(param): Observable<any> {
    return this.http.get(
      (this.url = this.getBaseUrl() + '/media/bucket-object-list'),
      { params: param }
    );
  }

  /**
   * Handles 'deleteImage' function. Calls get method with specific api address
   * along its param.
   *
   * @param param from model.
   */

  deleteImage(param): Observable<any> {
    return this.http.get(
      (this.url = this.getBaseUrl() + '/media/delete-file'),
      { params: param }
    );
  }
  searchFolder(param): Observable<any> {
    return this.http.get(
      (this.url = this.getBaseUrl() + '/media/search-folder'),
      { params: param }
    );
  }

  // Image Upload
  imageUpload(params) : Observable<any> {
    return this.http.put((this.url = this.getBaseUrl() + '/media/get-presigned-url-gcp?path=' +params.path + '&key=' +params.fileName + '&type=' + params.type), {});
  }

  // Image Upload
  imagePathUpload(params) : Observable<any> {
    return this.http.put((this.url = this.getBaseUrl() + '/media/convert-into-gif?path=' + params.path + '&key=' + params.fileName  + '&type=' + params.type), {});
  }

  // User Image Upload
  userImageUpload(params) : Observable<any> {
    return this.http.put((this.url = this.getBaseUrl() + '/media/get-presigned-url-gcp?path=' +params.path + '&key=' +params.fileName + '&type=' + params.type), {});
  }

  //Company Image Upload
  companyLogoImageUpload(params) : Observable<any> {
    return this.http.put((this.url = this.getBaseUrl() + '/media/get-presigned-url-gcp?path=' +params.path + '&key=' +params.fileName + '&type=' + params.type), {});
  }

   //Company Image Upload
   companyImageUpload(params) : Observable<any> {
    return this.http.put((this.url = this.getBaseUrl() + '/media/get-presigned-url-gcp?path=' +params.path + '&key=' +params.fileName + '&type=' + params.type), {});
  }

  //Company Image Upload
  deleveryPersonImageUpload(params) : Observable<any> {
    return this.http.put((this.url = this.getBaseUrl() + '/media/get-presigned-url-gcp?path=' +params.path + '&key=' +params.fileName + '&type=' + params.type), {});
  }

  // Upload Document
  uploadDocument(params) : Observable<any> {
    return this.http.put((this.url = this.getBaseUrl() + '/media/get-presigned-url-gcp?path=' +params.path + '&key=' +params.fileName + '&type=' + params.type), {});
  }
}